import axios from 'axios'
import urlHelper from './urlHelper'

const baseUrl = urlHelper('/api/userpageurl')

export default {
  getList () {
    return axios.get(baseUrl)
  },
  getById (id) {
    return axios.get(`${baseUrl}/${id}`)
  },
  add (pageNumber, title, url) {
    return axios.post(`${baseUrl}`, { pageNumber, title, url })
  },
  delete (id) {
    return axios.delete(`${baseUrl}/${id}`)
  }
}
